@if (showBadge$ | async) {
  @if (subscriptionTier$ | async; as tier) {
    @if (canNavigateToMyPlanPage$(tier) | async) {
      <div
        class="subscription-level clickable-subscription-level"
        (click)="handleOnSubLevelClick(tier)"
        >
        {{ subscriptionLevel$ | async | translate }}
      </div>
    } @else {
      <span class="subscription-level">
        {{ subscriptionLevel$ | async | translate }}
      </span>
    }
  }
}
